import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Checkbox } from 'ctm-components';
import { factoryOptions, selectedFactoryOptions } from '../../core/state_selectors';

/**
 * Renders the factoryOptions component
 * @param {Object} props - The component props
 * @param {func} props.dispatch - Dispatch function to toggle the checkboxes
 * @param {Array} props.options - The array of factory options
 * @param {Array} props.selectedOptions - The array of selected options
 * @returns {Node} - Returns factoryOptions component
 */
const _FactoryOptions = ({ dispatch, options, selectedOptions, isABTest }) => (
    <div>
        { !isABTest
        && (
            <span>Please select any options fitted below.</span>
        )}
        {
            options.map((option) => {
                const schema = {
                    stateKey: 'vertical.quote',
                    identifier: 'coverDetail.vehicle.factoryOptions',
                    field: { label: option.label, value: option.code },
                    isGrouped: true // Grouped checkbox expect values to be added as array in store
                };
                return (
                    <Checkbox
                        key={option.code}
                        dispatch={dispatch}
                        value={selectedOptions.includes(option.code) ? option.code : ''}
                        schema={schema}
                        touched={false}
                    />
                );
            })
        }
    </div>
);

_FactoryOptions.propTypes = {
    dispatch: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    selectedOptions: PropTypes.array.isRequired,
    isABTest: PropTypes.bool
};

/**
 * Maps the store state to component props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => {
    const factoryOptionSplitTest = state.getIn(['page', 'splitTrafficId']) === 'splitFactoryOptions';
    const factoryOptionExpTest = state.getIn(['page', 'experimentId']) === 'expFactoryOptions';
    return {
        options: factoryOptions(state).toJS(),
        selectedOptions: selectedFactoryOptions(state).toJS(),
        isABTest: (factoryOptionSplitTest || factoryOptionExpTest)
    };
};

const FactoryOptions = connect(mapStateToProps)(_FactoryOptions);

export { _FactoryOptions, FactoryOptions };
